"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOverwolfEventTypesSortToJSON = exports.GetOverwolfEventTypesSortFromJSONTyped = exports.GetOverwolfEventTypesSortFromJSON = exports.GetOverwolfEventTypesSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetOverwolfEventTypesSort;
(function (GetOverwolfEventTypesSort) {
    GetOverwolfEventTypesSort["CREATEDAT"] = "CREATED_AT";
    GetOverwolfEventTypesSort["NAME"] = "NAME";
})(GetOverwolfEventTypesSort = exports.GetOverwolfEventTypesSort || (exports.GetOverwolfEventTypesSort = {}));
function GetOverwolfEventTypesSortFromJSON(json) {
    return GetOverwolfEventTypesSortFromJSONTyped(json, false);
}
exports.GetOverwolfEventTypesSortFromJSON = GetOverwolfEventTypesSortFromJSON;
function GetOverwolfEventTypesSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetOverwolfEventTypesSortFromJSONTyped = GetOverwolfEventTypesSortFromJSONTyped;
function GetOverwolfEventTypesSortToJSON(value) {
    return value;
}
exports.GetOverwolfEventTypesSortToJSON = GetOverwolfEventTypesSortToJSON;
